/* eslint-disable quotes */
import { Question } from '../redux/Slices/StartTestSlice/newTemplete';

export const writtenQuestions: Question[] = [
  {
    id: '67f67836c880a548f00f46ba',
    isActive: true,
    createdDate: '2025-04-09T13:37:58.867',
    updatedDate: null,
    questionTypeId: '67f662a9c880a548f00f46a4',
    roundId: '67f4da5312b8026f68aca585',
    sectionId: '67f4dc9612b8026f68aca586',
    topicId: '67f4efdd12b8026f68aca58b',
    subTopic: 'Objective Reasoning',
    questionTitle: null,
    questionText:
      "Statement: /n America's defense secretary reiterated that they would continue to supply arms to Pakistan. /n Conclusions /n I. Pakistan is incapable of manufacturing arms. /n II. it would ensure peace in the region",
    explanation:
      "Pakistan s ability to manufacture arms is not being talked about in the statement. /n So Conclusion I does not follow. The fact Conclusion II cannot be deduced from the statement. /n So, Conclusions II also doesn't follow.",
    options: [
      {
        isActive: true,
        answerOption: 'neither I nor II follows',
        isCorrectAnswer: true,
        correctAnswer: null,
        answerPlaceHolder: null,
        answerFeildType: null
      },
      {
        isActive: true,
        answerOption: 'both I nor II follows',
        isCorrectAnswer: false,
        correctAnswer: null,
        answerPlaceHolder: null,
        answerFeildType: null
      },
      {
        isActive: true,
        answerOption: 'only conclusion I follows',
        isCorrectAnswer: false,
        correctAnswer: null,
        answerPlaceHolder: null,
        answerFeildType: null
      },
      {
        isActive: true,
        answerOption: 'only conclusion II follows',
        isCorrectAnswer: false,
        correctAnswer: null,
        answerPlaceHolder: null,
        answerFeildType: null
      }
    ],
    correctAnswer: 'neither I nor II follows',
    additionalProps: {
      additionalProp1: {},
      additionalProp2: {},
      additionalProp3: {}
    },
    isProgrammingQuestion: false
  },
  {
    id: '67f67defc880a548f00f46c2',
    isActive: true,
    createdDate: '2025-04-09T14:02:23.715',
    updatedDate: null,
    questionTypeId: '67f662a9c880a548f00f46a4',
    roundId: '67f4da5312b8026f68aca585',
    sectionId: '67f4dc9612b8026f68aca586',
    topicId: '67f4efdd12b8026f68aca58b',
    subTopic: 'Blood Relation',
    questionTitle: null,
    questionText:
      'A man says, ‘My mother’s husband’s only daughter is the sister of your father.’ How is the man related to the person spoken to?',
    explanation:
      'Mother’s husband is father. His only daughter is man’s sister, who is the person’s aunt. So, the man is the person’s uncle.',
    options: [
      {
        isActive: true,
        answerOption: 'Uncle',
        isCorrectAnswer: true,
        correctAnswer: null,
        answerPlaceHolder: null,
        answerFeildType: null
      },
      {
        isActive: true,
        answerOption: 'Cousin',
        isCorrectAnswer: false,
        correctAnswer: null,
        answerPlaceHolder: null,
        answerFeildType: null
      },
      {
        isActive: true,
        answerOption: 'Brother',
        isCorrectAnswer: false,
        correctAnswer: null,
        answerPlaceHolder: null,
        answerFeildType: null
      },
      {
        isActive: true,
        answerOption: 'Father',
        isCorrectAnswer: false,
        correctAnswer: null,
        answerPlaceHolder: null,
        answerFeildType: null
      },
      {
        isActive: true,
        answerOption: 'Grandfather',
        isCorrectAnswer: false,
        correctAnswer: null,
        answerPlaceHolder: null,
        answerFeildType: null
      }
    ],
    correctAnswer: 'Uncle',
    additionalProps: {
      additionalProp1: {},
      additionalProp2: {},
      additionalProp3: {}
    },
    isProgrammingQuestion: false
  }
];
